import { AppShell, Container } from "@mantine/core";
import { Outlet } from "react-router-dom";
import AppNavbar from "./AppNavbar";
import AppFooter from "./AppFooter";

export default function AppLayout() {
  return (
    <AppShell header={{ height: 60 }} footer={{ height: 48 }}>
      <AppShell.Header className="app-header" withBorder>
        <AppNavbar />
      </AppShell.Header>

      <AppShell.Main>
        <Container size="lg" py={{ base: "lg", sm: 48 }} px={{ base: "md", sm: "md" }}>
          <Outlet />
        </Container>
      </AppShell.Main>

      <AppShell.Footer className="app-header" withBorder>
        <AppFooter />
      </AppShell.Footer>
    </AppShell>
  );
}
